import type { LoaderDataFormatterResult } from '@/domains/docs-site/LoaderDataFormatter';
import { isClient } from '@/shared/util/ssr';
import React from 'react';

let clientCacheLoaderData: LoaderDataFormatterResult | undefined = undefined;

export function useClientCacheLoaderData(
  originData: LoaderDataFormatterResult | undefined,
): LoaderDataFormatterResult | undefined {
  const result = React.useMemo(() => {
    if (isClient && originData) {
      clientCacheLoaderData = originData;
    }

    return (
      originData ??
      (() => {
        if (isClient) {
          return clientCacheLoaderData;
        }

        return undefined;
      })()
    );
  }, [originData]);

  return result;
}

export function getClientCacheLoaderData() {
  return clientCacheLoaderData;
}
